export enum NotificationSeverity {
  SUCCESS = 'Success',
  INFO = 'Info',
  WARNING = 'Warning',
  ERROR = 'Error'
}
